/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get } from 'lodash';

/**
 * This component is used for managing user's accepted legal documents.
 *
 * @vue-prop {String} email the email of the user
 * @vue-prop {Object} organization the organization details
 * @vue-prop {Number} refresher the probe used to refresh this very component from the parent
 *
 * @category ui.components.organizations.participants
 * @exports Privacy
 * @component
 */
const __vue_script__ = {
    name: 'Privacy',

    props: {
        email: {
            type: String,
            default: ''
        },

        organization: {
            type: Object,
            required: true
        },

        refresher: {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            loading: true,
            acceptedLegalDocs: [],
            orgName: this.$services.org.getNameFromId(this.organization._id),
            error: null
        };
    },

    watch: {
        // not needed for now as we can't revoke the acceptance of legal document
        // refresher() {
        //     this.init();
        // },

        email: {
            immediate: true,
            handler() {
                this.init();
            }
        }
    },

    methods: {
        /**
         * Initializes the component.
         */
        async init() {
            try {
                this.loading = true;

                const result = await this.$services.legal.getAcceptedLegalDocs(this.orgName, this.email);

                if (result.ok) {
                    if (result.deleted) {
                        this.$emit('user:deleted', result.deleted);
                    }

                    this.acceptedLegalDocs = result.accepted_legal_docs;
                } else {
                    this.error = this.$t('organization.pax_management.sections.privacy.fetch_failure');
                }
            } catch (error) {
                this.error = get(error, 'response.data.error') || error.message;
            } finally {
                this.loading = false;
            }
        },

        /**
         * Get a preview link for legal document
         *
         * @param {String} legalDocId legal document ID
         * @returns {String} legal document preview link
         */
        getLegalDocPreviewLink(legalDocId) {
            return this.$services.legal.getDocumentPreviewUrl(legalDocId);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loader',{staticClass:"in-page participant-privacy",attrs:{"status":_vm.loading}},[(!_vm.error && _vm.acceptedLegalDocs.length)?_c('div',{staticClass:"table-wrapper"},[_c('table',{staticClass:"table-striped"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('organization.pax_management.sections.privacy.action')))]),_c('th',[_vm._v(_vm._s(_vm.$t('organization.pax_management.sections.privacy.time')))])])]),_c('tbody',_vm._l((_vm.acceptedLegalDocs),function(legalDoc){return _c('tr',[(legalDoc.type !== 'unsubscribe')?_c('td',[(legalDoc.paxName)?_c('i18n',{attrs:{"tag":"span","path":"organization.pax_management.sections.privacy.accepted_policy_with_name"}},[_c('span',[_vm._v(_vm._s(legalDoc.paxName))]),_c('a',{attrs:{"href":_vm.getLegalDocPreviewLink(legalDoc.legalDocId)}},[_vm._v(_vm._s(legalDoc.name))])]):_c('i18n',{attrs:{"tag":"span","path":"organization.pax_management.sections.privacy.accepted_policy"}},[_c('a',{attrs:{"href":_vm.getLegalDocPreviewLink(legalDoc.legalDocId)}},[_vm._v(_vm._s(legalDoc.name))])])],1):_vm._e(),(legalDoc.type === 'unsubscribe')?_c('td',{domProps:{"innerHTML":_vm._s(_vm.$t('organization.pax_management.sections.privacy.unsubscribed', [legalDoc.workspaceName]))}}):_vm._e(),_c('td',[_vm._v(_vm._s(_vm.$utils.time.tsToFormat(legalDoc.timestamp, 'llll')))])])}),0)])]):_vm._e(),(!_vm.error && !_vm.acceptedLegalDocs.length)?_c('div',{staticClass:"alert alert-info"},[_c('p',[_vm._v(_vm._s(_vm.$t('organization.pax_management.sections.privacy.nothing_found')))])]):_vm._e(),(_vm.error)?_c('div',{staticClass:"alert alert-error"},[_c('h2',[_vm._v(_vm._s(_vm.$t('general.error_occurred')))]),_c('p',[_vm._v(_vm._s(_vm.error))])]):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Privacy.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__